import styled from "styled-components";

// TEXT

// STYLES
export const Icon = styled.svg<{ $small?: boolean }>`
  height: ${({ $small }) => ($small ? "1rem" : "1.25rem")};
`;

// DATA

// TYPES

// CONSTANTS

// FUNCTIONS

// ASSETS
